import actions from "../../constants/actions";

export const subscribeNewsletter = email => {
    return {
        type: actions.SUBSCRIBE_NEWSLETTER,
        payload: {
            email
        }
    };
};
